import React, { useMemo } from "react";
import { Instances, Instance } from "@react-three/drei";
import { COLORS } from "../constants";

export default function Trees() {
  const positions = useMemo(() => {
    const arr = [];
    const ring = 26;
    for (let i = 0; i < 18; i++) {
      const a = (i / 18) * Math.PI * 2 + 0.15;
      const nearCardinal =
        Math.abs(Math.cos(a)) > 0.95 || Math.abs(Math.sin(a)) > 0.95;
      if (nearCardinal) continue;
      const r = ring + (Math.random() - 0.5) * 3;
      arr.push({
        x: Math.cos(a) * r,
        z: Math.sin(a) * r,
        s: 0.85 + Math.random() * 0.5,
        rot: Math.random() * Math.PI * 2,
      });
    }
    const corners = [
      [16, 16],
      [-16, 16],
      [16, -16],
      [-16, -16],
    ];
    corners.forEach(([cx, cz]) => {
      for (let i = 0; i < 3; i++) {
        arr.push({
          x: cx + (Math.random() - 0.5) * 6,
          z: cz + (Math.random() - 0.5) * 6,
          s: 0.9 + Math.random() * 0.4,
          rot: Math.random() * Math.PI * 2,
        });
      }
    });
    for (let i = 0; i < 40; i++) {
      const a = Math.random() * Math.PI * 2;
      const r = 45 + Math.random() * 20;
      arr.push({
        x: Math.cos(a) * r,
        z: Math.sin(a) * r,
        s: 1.0 + Math.random() * 0.7,
        rot: Math.random() * Math.PI * 2,
      });
    }
    return arr;
  }, []);

  return (
    <group>
      <Instances limit={positions.length} castShadow>
        <cylinderGeometry args={[0.3, 0.45, 3, 8]} />
        <meshStandardMaterial color={COLORS.bark} roughness={0.95} />
        {positions.map((p, i) => (
          <Instance
            key={`tr-${i}`}
            position={[p.x, 1.5 * p.s, p.z]}
            scale={[p.s, p.s, p.s]}
            rotation={[0, p.rot, 0]}
          />
        ))}
      </Instances>
      <Instances limit={positions.length * 3} castShadow>
        <icosahedronGeometry args={[1.6, 1]} />
        <meshStandardMaterial color={COLORS.leaves} roughness={0.85} flatShading />
        {positions.map((p, i) => (
          <React.Fragment key={`fo-${i}`}>
            <Instance
              position={[p.x, 3.4 * p.s, p.z]}
              scale={[p.s * 1.3, p.s * 1.1, p.s * 1.3]}
            />
            <Instance
              position={[p.x + 0.6 * p.s, 4.0 * p.s, p.z - 0.4 * p.s]}
              scale={[p.s * 1.05, p.s * 0.95, p.s * 1.05]}
            />
            <Instance
              position={[p.x - 0.5 * p.s, 4.1 * p.s, p.z + 0.5 * p.s]}
              scale={[p.s * 0.95, p.s * 0.9, p.s * 0.95]}
            />
          </React.Fragment>
        ))}
      </Instances>
    </group>
  );
}
